export const kcOptionsByPlant = {
  ทุเรียน: [
    { label: "1. การพัฒนาการทางกิ่ง ก้าน สาขา (Kc = 0.60)", value: 0.6 },
    { label: "2. การชักนำการออกดอก (Kc = 0)", value: 0 },
    { label: "3. การพัฒนาการของดอก (Kc = 0.75)", value: 0.75 },
    { label: "4. การติดผล (Kc = 0.50)", value: 0.5 },
    { label: "5. การพัฒนาของผลอ่อน (Kc = 0.60)", value: 0.6 },
    { label: "6. การเจริญเติบโตของผล (Kc = 0.85)", value: 0.85 },
    { label: "7. การเริ่มสุกแก่ (Kc = 0.75)", value: 0.75 },
  ],
  "มังคุด พันธุ์พื้นเมือง": [
    { label: "1. ปีที่ 1 (Kc = 0.81)", value: 0.81 },
    { label: "2. ปีที่ 2 (Kc = 0.91)", value: 0.91 },
    { label: "3. ปีที่ 3 ช่วง 7 เดือน (Kc = 1.04)", value: 1.04 },
  ],
  "มะละกอ พันธุ์ฮอลแลนด์": [
    { label: "เดือนที่ 1.  (Kc = 1.02)", value: 1.02 },
    { label: "เดือนที่ 2.  (Kc = 1.11)", value: 1.11 },
    { label: "เดือนที่ 3.  (Kc = 0.98)", value: 0.98 },
    { label: "เดือนที่ 4.  (Kc = 1.28)", value: 1.28 },
    { label: "เดือนที่ 5.  (Kc = 1.11)", value: 1.11 },
    { label: "เดือนที่ 6.  (Kc = 1.72)", value: 1.72 },
    { label: "เดือนที่ 7.  (Kc = 1.95)", value: 1.95 },
    { label: "เดือนที่ 8.  (Kc = 2.32)", value: 2.32 },
    { label: "เดือนที่ 9.  (Kc = 1.46)", value: 1.46 },
    { label: "เดือนที่ 10.  (Kc = 1.54)", value: 1.54 },
    { label: "เดือนที่ 11.  (Kc = 1.39)", value: 1.39 },
  ],
};

export const plantEn = {
  "ทุเรียน": {
    name: "Durian",
    labelEn: [
      "1. Vegetative growth stage (Kc = 0.60)",
      "2. Floral induction stage (Kc = 0.00)",
      "3. Floral development stage (Kc = 0.75)",
      "4. Fruit setting stage (Kc = 0.50)",
      "5. Early fruit growth stage (Kc = 0.60)",
      "6. Late fruit growth stage (Kc = 0.85)",
      "7. Fruit maturity stage (Kc = 0.75)"
    ]
  },
  "มังคุด พันธุ์พื้นเมือง": {
    name: "Mangosteen (Local Variety)",
    labelEn: [
      "1. Year 1 (Kc = 0.89)",
      "2. Year 2 (Kc = 1.00)",
      "3. Year 3, 7 months period (Kc = 1.04)"
    ]
  },
  "มะละกอ พันธุ์ฮอลแลนด์": {
    name: "Papaya (Holland Variety)",
    labelEn: [
      "Month 1 (Kc = 1.02)",
      "Month 2 (Kc = 1.11)",
      "Month 3 (Kc = 0.98)",
      "Month 4 (Kc = 1.28)",
      "Month 5 (Kc = 1.11)",
      "Month 6 (Kc = 1.72)",
      "Month 7 (Kc = 1.95)",
      "Month 8 (Kc = 2.32)",
      "Month 9 (Kc = 1.46)",
      "Month 10 (Kc = 1.54)",
      "Month 11 (Kc = 1.39)"
    ]
  }
};
